import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormPentagon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-pentagon"><path d="M9.79501 2.42456C11.1092 1.46975 12.8889 1.46987 14.2032 2.42456L20.4249 6.94409C21.7391 7.89895 22.2891 9.59243 21.7872 11.1374L19.4112 18.4509C18.9092 19.996 17.4684 21.0417 15.8438 21.0417H8.15438C6.52987 21.0417 5.08901 19.9959 4.587 18.4509L2.21103 11.1374C1.70921 9.59247 2.25911 7.89892 3.57333 6.94409L9.79501 2.42456Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFormPentagon;
